/* Outdoor Lamp v2 — shared scroll-reveal + stat count-up. Self-guards so it runs once even if multiple sections load it. */
(function(){
  if (window.__olv2Init) return;
  window.__olv2Init = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el){
    if (reduce) return;
    var target = parseFloat(el.dataset.count), pre = el.dataset.prefix || '', suf = el.dataset.suffix || '';
    var start = performance.now(), dur = 900;
    function tick(now){
      var p = Math.min(1, (now - start) / dur), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(target * eased) + suf;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init(){
    var reveals = [].slice.call(document.querySelectorAll('.olv2 .reveal'));
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            e.target.classList.add('in');
            e.target.querySelectorAll('[data-count]').forEach(countUp);
            io.unobserve(e.target);
          }
        });
      }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add('in'); });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-run for sections dropped in via the theme editor.
  if (window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load', function(){
      document.querySelectorAll('.olv2 .reveal').forEach(function(el){ el.classList.add('in'); });
    });
  }
})();

/* Anchor CTAs: theme.js's global '[href^="#"]' delegate preventDefaults and
   relies on smooth window.scrollTo, which silently no-ops on these landing
   pages (scroll anchoring + lazy images cancel the animation). Handle olv2
   anchors ourselves in the capture phase and verify the scroll actually
   moved, falling back to an instant jump. */
(function () {
  if (window.__olv2AnchorFix) return;
  window.__olv2AnchorFix = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.olv2 a[href^="#"]');
    if (!a) return;
    var sel = a.getAttribute('href');
    if (!sel || sel === '#') return;
    var el = document.querySelector(sel);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation(); // keep theme.js's body delegate from double-handling
    var bar = document.querySelector('.AnnouncementBar');
    var top = el.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.clientHeight : 0);
    var from = window.pageYOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    setTimeout(function () {
      // If the smooth scroll was cancelled (barely moved and still far away), jump.
      if (Math.abs(window.pageYOffset - from) < 30 && Math.abs(window.pageYOffset - top) > 50) {
        window.scrollTo(0, top);
      }
    }, 400);
  }, true); // capture: runs before theme.js's bubble-phase delegate on body
})();
